/**
 * Legacy SettlementsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.settlementsApi`) keep resolving.
 *
 * The actual SettlementsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/settlements/settlements-api.service.ts
 */
angular.module("acme.common.service.settlementsApi", []);
